export default function EmptyState() {
  return (
    <div
      className="flex flex-col items-center justify-center text-center"
      style={{ height: 'calc(-7rem + 100vh)' }}
    >
      <h2 className="text-lg font-semibold mb-3">Belum Ada Asesmen</h2>
      <p className="text-sm text-type-basic-dark max-w-[312px]">
        Asesmen yang Anda gunakan atau unduh akan muncul di halaman ini.
      </p>
    </div>
  )
}
